module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_70.d22b8c2b.gif";